// src/providers/TranslationProvider.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { t, addLanguageChangeListener, removeLanguageChangeListener } from '../i18n';


// Çeviri bağlamı oluştur
const TranslationContext = createContext();

/**
 * Tüm uygulamayı saran çeviri sağlayıcısı
 * Bu bileşen, tüm uygulamaya t fonksiyonunu içeren bir bağlam sağlar
 */
export const TranslationProvider = ({ children }) => {
  const { currentLanguage } = useLanguage();
  
  // Çeviri fonksiyonunu sağla
  const value = {
    t,
    currentLanguage
  };
  
  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

/**
 * Çeviri hook'u - herhangi bir bileşenden kullanılabilir
 * @returns {Object} { t, currentLanguage }
 */
export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation hook must be used within TranslationProvider');
  }
  return context;
};

export default TranslationProvider;